(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var Drawer = window.Faubourg && window.Faubourg.Drawer;
    if (!Drawer) return;

    class ContentDrawer extends Drawer {}

    if (!customElements.get('faubourg-content-drawer')) {
      customElements.define('faubourg-content-drawer', ContentDrawer);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["expandable-text"] && !Shopify.designMode) return;
  try {
    class FaubourgExpandableText extends HTMLElement {
    connectedCallback() {
      this.body = this.querySelector('[data-expandable-text-body]');
      this.toggle = this.querySelector('[data-expandable-text-toggle]');
      this.label = this.querySelector('[data-expandable-text-label]');
      if (!this.body || !this.toggle) return;

      this.expandLabel = this.label.textContent.trim();
      this.collapseLabel = this.toggle.dataset.collapseLabel || this.expandLabel;

      this.toggle.addEventListener('click', this.onClick);

      // The element, not its text: closed, it keeps one height whatever the
      // measure finds, so measuring never answers itself. A font that arrives
      // late rewraps the text inside that height and is heard on its own.
      this.observer = new ResizeObserver(this.measure);
      this.observer.observe(this);
      document.fonts?.addEventListener('loadingdone', this.measure);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      document.fonts?.removeEventListener('loadingdone', this.measure);
      this.toggle?.removeEventListener('click', this.onClick);
    }

    measure = () => {
      if (this.hasAttribute('data-expanded')) return;

      this.setAttribute('data-measuring', '');
      const unmeasured = this.body.getBoundingClientRect().height;
      const overflowing = this.body.scrollHeight > this.body.clientHeight + 1;
      this.removeAttribute('data-measuring');
      this.toggleAttribute('data-overflowing', overflowing);
      this.toggle.hidden = !overflowing;
      if (!overflowing) return;

      // The toggle stands where the line it hides stood. What that line had
      // beyond the toggle's own height goes above it; a line shorter than the
      // toggle lets it reach up into the leading of the line before.
      const line = unmeasured - this.body.getBoundingClientRect().height;
      const offset = line - this.toggle.getBoundingClientRect().height;
      this.style.setProperty('--expandable-text-toggle-offset', `${offset}px`);
    };

    onClick = () => {
      const expanded = this.toggleAttribute('data-expanded');
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.label.textContent = expanded ? this.collapseLabel : this.expandLabel;
      if (!expanded) this.measure();
    };
  }

  if (!customElements.get('faubourg-expandable-text')) {
    customElements.define('faubourg-expandable-text', FaubourgExpandableText);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-buy-buttons"] && !Shopify.designMode) return;
  try {
    class FaubourgBuyDock extends HTMLElement {
    // Every dock on the page, because the property they publish is the page's:
    // a dock stepping away must not clear what another is still asking for.
    static docks = new Set();

    // How much of the foot of the screen the bar covers, for the page to keep
    // what has focus clear of it (`scroll-padding-block-end`, in the layout).
    static publishClearance() {
      const root = document.documentElement;
      if (!FaubourgBuyDock.docks.size) {
        root.style.removeProperty('--dock-clearance');
        return;
      }

      let clearance = 0;
      for (const dock of FaubourgBuyDock.docks) {
        if (dock.hasAttribute('data-shown')) clearance = Math.max(clearance, dock.offsetHeight);
      }
      root.style.setProperty('--dock-clearance', `${clearance}px`);
    }

    connectedCallback() {
      // A bar pinned to the screen belongs to a page. Inside a drawer the
      // real button is already within reach, and the drawer is the screen.
      if (this.closest('[data-drawer-panel]')) return;

      this.button = this.querySelector('[data-dock-button]');
      this.section = this.closest('[data-section-id]');
      this.main = this.section?.querySelector('[data-cart-add-submit]');
      if (!this.button || !this.section || !this.main) return;

      this.phone = window.matchMedia('(max-width: 749px)');
      this.frame = 0;
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      };
      this.onPending = (event) => {
        if (event.detail?.sectionId !== this.dataset.forSection) return;
        this.button.disabled = Boolean(event.detail.pending);
      };

      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule);
      this.phone.addEventListener('change', this.schedule);
      document.addEventListener('variant:pending', this.onPending);

      // The bar's height follows its text size and the device's safe area.
      if (typeof ResizeObserver === 'function') {
        this.observer = new ResizeObserver(this.schedule);
        this.observer.observe(this);
      }

      FaubourgBuyDock.docks.add(this);
      this.hidden = false;
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      this.phone?.removeEventListener('change', this.schedule);
      document.removeEventListener('variant:pending', this.onPending);
      if (this.frame) cancelAnimationFrame(this.frame);
      this.observer?.disconnect();

      if (FaubourgBuyDock.docks.delete(this)) FaubourgBuyDock.publishClearance();
    }

    // Shown while the real button is out of view and this section fills the
    // strip the bar occupies, so the bar only ever covers its own section: it
    // waits until the section has come up past it, and the moment the next
    // one comes up, it steps away. A product further down a home page is not
    // yet in reach of anything, however far below its button is.
    update() {
      const height = innerHeight;
      const main = this.main.getBoundingClientRect();
      const section = this.section.getBoundingClientRect();
      const mainInView = main.bottom > 0 && main.top < height;
      const underBar = section.top <= height - this.offsetHeight && section.bottom > height;
      const shown = this.phone.matches && !mainInView && underBar;

      this.toggleAttribute('data-shown', shown);
      this.inert = !shown;
      FaubourgBuyDock.publishClearance();
    }
  }

  if (!customElements.get('faubourg-buy-dock')) {
    customElements.define('faubourg-buy-dock', FaubourgBuyDock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-gift-wrap"] && !Shopify.designMode) return;
  try {
    (function () {
    var scope = (window.Faubourg = window.Faubourg || {});
    if (scope.giftWrapInstalled) return;
    scope.giftWrapInstalled = true;

    // A nested line names its parent by the variant it is added with, and the
    // request is refused if that is not the variant in it. The picker swaps the
    // variant after the page is drawn, so the parent is said as the form is
    // read, whether the press is answered by cart.js or natively, for every
    // wrap the form carries. A note left empty is a property Shopify would
    // keep, and say "Gift message:" to no one.
    document.addEventListener('formdata', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-cart-add-form')) return;

      var data = event.formData;
      var variants = data.getAll('id');
      if (variants.length) {
        Array.from(data.keys()).forEach(function (name) {
          var wrap = /^items\[(\d+)\]\[id\]$/.exec(name);
          if (wrap) data.set('items[' + wrap[1] + '][parent_id]', variants[variants.length - 1]);
        });
      }

      Array.from(data.keys()).forEach(function (name) {
        if (/^items\[\d+\]\[properties\]/.test(name) && data.get(name) === '') data.delete(name);
      });
    });

    // Said once the handler above is listening: the choice for a product with
    // several variants is only offered to a form that something will name the
    // parent on.
    document.documentElement.setAttribute('data-gift-wrap-ready', '');
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-pickup-availability"] && !Shopify.designMode) return;
  try {
    /*
   * No Drawer means no registration: the trigger stays hidden and the
   * accordion stays in its place, which is the path a shopper keeps when the
   * primitive never arrives.
   */
  (function () {
    var Drawer = window.Faubourg && window.Faubourg.Drawer;
    if (!Drawer) return;
    if (customElements.get('faubourg-pickup-drawer')) return;

    class PickupDrawer extends Drawer {}
    customElements.define('faubourg-pickup-drawer', PickupDrawer);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-restock"] && !Shopify.designMode) return;
  try {
    (function () {
    // The picker swaps the buy buttons, not this block: the block follows the
    // event it sends after each swap, for its own section only.
    document.addEventListener('variant:changed', function (event) {
      var detail = event.detail || {};
      document.querySelectorAll('[data-restock]').forEach(function (root) {
        if (detail.sectionId && root.dataset.sectionId !== detail.sectionId) return;
        if (root.querySelector('[role="status"]')) return;

        var titles = {};
        try {
          titles = JSON.parse(root.querySelector('[data-restock-variants]').textContent);
        } catch (error) {}

        var title = titles[detail.variantId] || '';
        if (title === 'Default Title') title = '';

        var variantField = root.querySelector('[data-restock-variant]');
        var linkField = root.querySelector('[data-restock-link]');
        var bodyField = root.querySelector('[data-restock-body]');

        if (variantField) variantField.value = title;
        if (linkField && detail.variantId) {
          var link = new URL(linkField.value);
          link.searchParams.set('variant', detail.variantId);
          linkField.value = link.toString();
        }
        if (bodyField) {
          bodyField.value = bodyField.value.replace(/ \(.*\)$/, '') + (title ? ' (' + title + ')' : '');
        }

        root.hidden = detail.available === true;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
